import {DataTableColumn} from "mantine-datatable";
import {MeterAssignment} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";

export const useTableColumns = () => {

    const columns: DataTableColumn<MeterAssignment>[] = [
        {
            accessor: 'customerId',
            title: I18n.get('Customer'),
            width: '1fr',
            render: (item: MeterAssignment) => item.customerId,
        },
        {
            accessor: 'meterId',
            title: I18n.get('Meter'),
            width: '1fr',
            render: (item: MeterAssignment) => item.meterId,
        },
        {
            accessor: 'channel',
            title: I18n.get('Channel'),
            width: '1fr',
            render: (item: MeterAssignment) => item.channel,
        },
        {
            accessor: 'freeTierQuantity',
            title: I18n.get('Free Tier'),
            width: '1fr',
            render: (item: MeterAssignment) => item.freeTierQuantity ?? '-',
        },
        {
            accessor: 'committedQuantity',
            title: I18n.get('Committed'),
            width: '1fr',
            render: (item: MeterAssignment) => item.committedQuantity ?? '-',
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: MeterAssignment) => <StatusBadge status={item.status}/>,
        },
        {
            accessor: 'effectiveFrom',
            title: I18n.get('Effective From'),
            width: '1fr',
            render: (item: MeterAssignment) => formatTimestamp(item.effectiveFrom as string),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: MeterAssignment) => formatTimestamp(item.created as string),
        },

    ];

    return {
        columns,
    }
}
